import '@splidejs/splide/css';
import Splide from '@splidejs/splide';


const initializeBlock = function( $block ){
  // console.log($block);
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  const isAdmin = document.body.classList.contains('wp-admin');
  
  let slider;
  let args = {
    gap: '3rem',
    drag: isAdmin ? false : true,
    arrows: false,
  };

  if($block.classList.contains('slider-auto-start')){
    args.autoplay = true;
    args.interval = $block.getAttribute('data-td-speed') || 3000;
    args.pauseOnHover = false;
  }

  if($block.getAttribute('data-transition-type') === 'fade'){
    args.type = 'fade';
    args.rewind = true;
    args.speed = 1400;
  }

  if($block.classList.contains('no-pagination')){
    args.pagination = false;
  }

  if($block.classList.contains('slider_block')){
    slider = $block.querySelector('.slider_block__slider');
  }
  else if($block.classList.contains('grid-container') && $block.classList.contains('mobile-slider')){
    slider = $block;
    const mobilePerPage = $block.getAttribute('data-slides-per-page-mobile') || 1;
    const tabletPerPage = $block.getAttribute('data-slides-per-page-tablet') || 1;

    args.perPage = parseInt(mobilePerPage);
    args.mediaQuery = 'min';
    args.breakpoints = {
      640: {
        perPage: parseInt(tabletPerPage),
      },
      991: {
        destroy: true,
      }
    }
  }
  else if($block.classList.contains('lwir')){
    slider = $block.querySelector('.lwir__slider');
  }

  if(!slider){ 
    // console.log('no slider found');
    return; 
  }

  if(slider.splide){
    // If the slider already exists, destroy it first
    slider.splide.destroy();
    slider.splide = null;
  }

  // For slides that don't already have the .splide__slide class, add it
  const slides = slider.querySelectorAll('.splide__list > *');
  Array.prototype.forEach.call(slides, function(el, i){
    if(!el.classList.contains('splide__slide')){
      el.classList.add('splide__slide');
    }
  });

  if(slider){
    // Create the slider
    slider.splide = new Splide(slider, args); 
    
    let currentSlideIndex = 0;

    // Update navigation count / progess bar
    const navWrap = slider.querySelector('.splide__arrows');
    const leftArrow = slider.querySelector('.splide__arrow--prev');
    const rightArrow = slider.querySelector('.splide__arrow--next');
    
    if(!!navWrap){

      slider.splide.on('move', (newIndex) => {
        if(args.rewind || args.rewindByDrag){ return; }
        
        const leftArrow = slider.querySelector('.splide__arrow--prev');
        const rightArrow = slider.querySelector('.splide__arrow--next');

        if(newIndex == 0 && !!leftArrow){
          leftArrow.disabled = true;
        }
        else if(!!leftArrow && leftArrow.disabled){
          leftArrow.disabled = false;
        }
        
        if(newIndex > (slider.splide.length - 1 - slider.splide.options.perPage) && !!rightArrow){
          rightArrow.disabled = true;
        }
        else if(!!rightArrow && rightArrow.disabled){
          rightArrow.disabled = false;
        }
      });

      slider.splide.on( 'move mounted resized', () => {
        let current = currentSlideIndex + 1;
        const {Slides} = slider.splide.Components;
  
        // Progress bar
        const lastVisibleSlide = current + (slider.splide.options.perPage - 1);
        const progressBar = slider.querySelector('.progress');
        if(progressBar){
          let progress = Math.round(lastVisibleSlide / Slides.getLength() * 100);
          
          // Ensure resize events don't trip things up. 
          if(progress > 100){
            progress = 100;
          }
  
          progressBar.style.setProperty('--progress', progress + '%');
        }
      } );
    }

    // Ensure active class on new slide is added on move, rather than after move
    slider.splide.on('move', (newIndex) => {
      currentSlideIndex = newIndex;
      
      const allSlides = slider.querySelectorAll('.splide__slide');
      Array.prototype.forEach.call(allSlides, function(el, i){
        el.classList.remove('is-active');
        el.classList.remove('is-visible');
        
        // Add visible class to slides in view
        if(i >= newIndex && i < (newIndex + slider.splide.options.perPage)){
          el.classList.add('is-visible');
        }
        // Add active class to the current slide
        if(i == newIndex){
          el.classList.add('is-active');
        }
      });
    });
    
    // Mount the slider
    slider.splide.mount();

    // if there's a map, get it's height and set a css property on the slider block
    const mapWrapper = $block.querySelector('.slider_block__map');
    if(!!mapWrapper){
      const setMapHeight = () => {
        const height = mapWrapper.clientHeight;
        $block.style.setProperty('--slider-map-height', height + 'px');
      }
      setMapHeight();

      let mapDebouncer
      window.addEventListener('resize', () => {
        clearTimeout( mapDebouncer );
        mapDebouncer = setTimeout( () => {
          setMapHeight();
        }, 50 );
      });
    }
  }
}

const AdjustMobileGridSliderMarkup = function( $block ){
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // Add splide elements
  if(!$block.classList.contains('splide')){
    const inner = $block.querySelector('.grid-container_wrapper');
    $block.classList.add('splide');

    const splideTrack = document.createElement('div');
    splideTrack.classList.add('splide__track');

    inner.classList.add('splide__list');
    inner.childNodes.forEach(child => {
      if(child.nodeType === Node.ELEMENT_NODE){
        child.classList.add('splide__slide');
      }
    });

    splideTrack.appendChild(inner);
    $block.appendChild(splideTrack);
  }

}


const manageLWIRBlockState = ( $block ) => {
  const width = $block.clientWidth;
  const breakpoint = 950;
  if(width <= breakpoint){
    // Initialize slider if not already initialized
    if( !$block.querySelector('.lwir__slider').splide ){
      initializeBlock( $block );
    }
  }
  else{
    // Destroy slider if exists
    const slider = $block.querySelector('.lwir__slider');
    if( slider.splide ){
      slider.splide.destroy();
      slider.splide = null;
    }
  }
};


// Initialize the slider on the front end only
export const initializeSlider = function(){
  // Grid Container Mobile Sliders
  const gridMobileSliders = document.querySelectorAll('.grid-container.mobile-slider');
  Array.prototype.forEach.call(gridMobileSliders, function(el, i){
    AdjustMobileGridSliderMarkup(el);
  });

  const sliders = document.querySelectorAll('.slider_block, .grid-container.mobile-slider, .lwir');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });

  // Watch LWIR blocks for content width to determine when to destroy/rebuild slider
  const lwirBlocks = document.querySelectorAll('.lwir');
  Array.prototype.forEach.call(lwirBlocks, function(el, i){
    manageLWIRBlockState( el );

    let resizeDebouncer;
    window.addEventListener('resize', () => {
      clearTimeout( resizeDebouncer );
      resizeDebouncer = setTimeout( () => {
        manageLWIRBlockState( el );
      }, 100 );
    });
  });
};


// Initialize the slider in the editor
export const initializeSliderEditor = () => {
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=slider', ( $block ) => {
      const slider = $block[0].querySelector('.slider_block');
      if(!slider) return;
      initializeBlock( slider );
    });
  }
}